import { render, staticRenderFns } from "./MapaDesenvolvimentoEconomico.vue?vue&type=template&id=3e175d79"
import script from "./MapaDesenvolvimentoEconomico.vue?vue&type=script&lang=js"
export * from "./MapaDesenvolvimentoEconomico.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports